import { render } from "./authorizeBySystem.vue?vue&type=template&id=5053c75c&scoped=true"
import script from "./authorizeBySystem.vue?vue&type=script&lang=js"
export * from "./authorizeBySystem.vue?vue&type=script&lang=js"

import "./authorizeBySystem.vue?vue&type=style&index=0&id=5053c75c&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5053c75c"]])

export default __exports__